import API from '@/api'
import { setImageDimensions } from '../utils'

const state = {
  item: {},
  promises: {
    fetch: null,
  },
}

const mutations = {
  set(state, payload) {
    state.item = payload
  },
  setPromise(state, { key, promise }) {
    state.promises[key] = promise
  },
}

const actions = {
  fetch({ commit, state }) {
    if (state.item.id) return state.item
    let promise = API.getProject().then(async data => {
      data.media.gallery = await setImageDimensions(data.media.gallery)

      commit('set', data)

      if (API.projectType === 'singular')
        commit('Residential/set', { ...data.residentials[0], project: data }, { root: true })
      return data
    })
    commit('setPromise', { key: 'fetch', promise })
    return promise
  },
  forceFetchProject({ commit, state }) {
    let promise = API.getProject().then(async data => {
      data.media.gallery = await setImageDimensions(data.media.gallery)

      commit('set', data)
      if (API.projectType === 'singular')
        commit('Residential/set', { ...data.residentials[0], project: data }, { root: true })
      return data
    })
    commit('setPromise', { key: 'fetch', promise })
    return promise
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
